
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Car, Truck, Bike, Recycle } from "lucide-react";

const Vehicules = () => {
  const services = [
    {
      title: "Véhicules légers",
      description: "Recyclage et destruction de voitures, motos, scooters",
      icon: Car,
      types: ["Voitures", "Motos", "Scooters", "Quads"]
    },
    {
      title: "Poids lourds",
      description: "Traitement des camions, bus et véhicules industriels",
      icon: Truck,
      types: ["Camions", "Bus", "Tracteurs", "Engins BTP"]
    },
    {
      title: "Deux-roues",
      description: "Spécialistes du recyclage de motos et cyclomoteurs",
      icon: Bike,
      types: ["Motos", "Cyclomoteurs", "Vélos électriques", "Trottinettes"]
    },
    {
      title: "Valorisation",
      description: "Récupération et valorisation des matériaux",
      icon: Recycle,
      types: ["Métaux", "Plastiques", "Batteries", "Fluides"]
    }
  ];

  return (
    <div className="min-h-screen flex flex-col">
      <SEO 
        title="Recyclage de Véhicules - Groupe Fabre Environnement"
        description="Recyclage et destruction de véhicules hors d'usage : voitures, motos, poids lourds. Centre VHU agréé préfecture."
        canonical="/services/vehicules"
      />
      <Navbar />
      
      <main className="flex-1 mt-16">
        {/* Hero Section */}
        <div className="bg-gradient-to-r from-red-600 to-red-700 text-white py-16">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">Recyclage de Véhicules</h1>
              <p className="text-xl opacity-90">
                Centre VHU agréé pour le recyclage et la destruction 
                de tous types de véhicules hors d'usage.
              </p>
            </div>
          </div>
        </div>

        {/* Services Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {services.map((service, index) => {
                const IconComponent = service.icon;
                return (
                  <div key={index} className="bg-gray-50 p-8 rounded-lg">
                    <div className="w-16 h-16 bg-red-600 rounded-lg flex items-center justify-center mb-6">
                      <IconComponent className="h-8 w-8 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-fabre-gray mb-4">{service.title}</h3>
                    <p className="text-gray-600 mb-4">{service.description}</p>
                    <div className="space-y-2">
                      {service.types.map((type, idx) => (
                        <span key={idx} className="inline-block bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm mr-2 mb-2">
                          {type}
                        </span>
                      ))}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Process Section */}
        <section className="py-16 bg-red-50">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-3xl font-bold text-fabre-gray mb-12 text-center">
                Notre processus de recyclage
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                    1
                  </div>
                  <h3 className="text-lg font-bold text-fabre-gray mb-2">Collecte</h3>
                  <p className="text-gray-600 text-sm">Enlèvement gratuit de votre véhicule</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                    2
                  </div>
                  <h3 className="text-lg font-bold text-fabre-gray mb-2">Dépollution</h3>
                  <p className="text-gray-600 text-sm">Extraction des fluides et matières dangereuses</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                    3
                  </div>
                  <h3 className="text-lg font-bold text-fabre-gray mb-2">Démontage</h3>
                  <p className="text-gray-600 text-sm">Récupération des pièces réutilisables</p>
                </div>
                <div className="text-center">
                  <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                    4
                  </div>
                  <h3 className="text-lg font-bold text-fabre-gray mb-2">Broyage</h3>
                  <p className="text-gray-600 text-sm">Valorisation des matériaux restants</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-fabre-gray mb-6">
              Votre véhicule ne roule plus ?
            </h2>
            <p className="text-gray-600 mb-8 max-w-2xl mx-auto">
              Nous nous occupons de tout : enlèvement gratuit, 
              certificat de destruction et recyclage dans le respect 
              de l'environnement.
            </p>
            <Link
              to="/contact"
              className="inline-block bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-md font-medium transition-colors"
            >
              Demander un enlèvement
            </Link>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Vehicules;
